import { Icon } from '@chakra-ui/react';

export const CarouselAdvanceIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="32px"
		height="31px"
		viewBox="0 0 32 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="15.7837"
			cy="15.4542"
			r="14.4992"
			transform="rotate(-180 15.7837 15.4542)"
			stroke={color}
			strokeWidth="1.66195"
		/>
		<path
			d="M13.5834 10.6397L19.0146 15.96L13.5834 21.2803"
			stroke="text"
			strokeWidth="1.66195"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
